import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Info } from 'lucide-react';

const TooltipHelper = ({ text }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const iconRef = useRef(null);
    const tooltipRef = useRef(null);

    useEffect(() => {
        if (isVisible && iconRef.current) {
            const updatePosition = () => {
                const rect = iconRef.current.getBoundingClientRect();
                setPosition({
                    top: rect.top + rect.height / 2,
                    left: rect.right + 12,
                });
            };

            updatePosition();
            window.addEventListener('scroll', updatePosition, true);
            window.addEventListener('resize', updatePosition);

            return () => {
                window.removeEventListener('scroll', updatePosition, true);
                window.removeEventListener('resize', updatePosition);
            };
        }
    }, [isVisible]);

    const tooltipContent = isVisible && (
        <div
            ref={tooltipRef}
            className="fixed z-[99999] bg-[#09274A] text-white text-sm rounded-lg px-4 py-2 shadow-xl w-64 text-left pointer-events-none whitespace-normal"
            style={{
                top: `${position.top}px`,
                left: `${position.left}px`,
                transform: 'translateY(-50%)',
            }}
        >
            {text}
            {/* Flecha del tooltip */}
            <div className="absolute right-full top-1/2 -translate-y-1/2 -mr-1">
                <div className="w-2 h-2 bg-[#09274A] rotate-45"></div>
            </div>
        </div>
    );

    return (
        <>
            <div 
                className="relative flex items-center ml-1"
                onMouseEnter={() => setIsVisible(true)}
                onMouseLeave={() => setIsVisible(false)}
            >
                <Info 
                    ref={iconRef}
                    className="w-4 h-4 text-[#0488AF] cursor-pointer" 
                />
            </div>
            {typeof document !== 'undefined' && createPortal(tooltipContent, document.body)}
        </>
    );
};

export default TooltipHelper;
